import moment from 'moment'

export const config = {
  rowSelection: false,
  // pagination: false,
  columns: [
    {
      title: '序号',
      dataIndex: 'number',
      width: 200,
    },
    {
      title: '节点任务',
      dataIndex: 'taskName',
      width: 200,
    },
    {
      title: '节点按钮',
      dataIndex: 'taskTypeName',
      width: 200,
    },
    {
      title: '是否核心',
      dataIndex: 'coreTaskFlag',
      width: 200,
      render: v => {
        return v ? '是' : '否'
      },
    },
    {
      title: '职责类型',
      dataIndex: 'dutyTypeName',
      width: 200,
    },
  ],
  search: [
    {
      label: '名称',
      name: 'taskName',
    },
  ],
  footer: [],
}
